/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 23 2023
 **/

import React from "react";
import { createPortal } from "react-dom";
import { useAtomValue } from "jotai";
import { JotaiStore } from "@/frameworks/libraries/commons";

import Modal from "./Modal";
import { ModalBackdropPosition } from "./private/emotion";
import useModal from "./useModal";
import { modalDimensionsAtom, modalListAtom } from "./private/atom";

export default function ModalContainer({ children }: { children: React.ReactNode }) {
	const modalList = useAtomValue(modalListAtom, { store: JotaiStore });

	const dimensions = useAtomValue(modalDimensionsAtom, { store: JotaiStore });

	const { hide } = useModal();

	// useEffect(() => {
	// 	console.debug("modalEventList", modalEventList);
	// }, [modalEventList]);

	return (
		<React.Fragment>
			{children}
			{modalList.length > 0 &&
				createPortal(
					<>
						{modalList?.map((item) => (
							<div key={item.id} css={[ModalBackdropPosition(item.zIndex)]}>
								<Modal
									preventHideByDimmed={item.preventHideByDimmed}
									hide={() => {
										hide(item.id);
										item.onHide?.();
									}}
									{...dimensions}
								>
									{item.content}
								</Modal>
							</div>
						))}
					</>,
					document.body
				)}
		</React.Fragment>
	);
}
